import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { toast } from 'sonner';
import api from '../lib/api';

const registerSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters'),
  email: z.string().email('Invalid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
});

export default function RegisterPage() {
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: zodResolver(registerSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await api.post('/auth/register', data);
      toast.success('Registration successful! Please check your email to verify.');
      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };
return (
  <div className="min-h-screen flex items-center justify-center p-4 bg-background">
    <div className="w-full max-w-md bg-surface border border-border/40 rounded-sm p-8">
      <div className="mb-6">
        <h1 className="text-3xl font-black font-heading tracking-tight text-primary">
          MROD SUPERBOT
        </h1>
        <p className="text-sm text-text-muted mt-1">
          Create your account
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2 text-text-main">
            Name
          </label>
          <input
            type="text"
            {...register('name')}
            className="w-full px-4 py-2 bg-black/50 border border-border focus:border-primary text-text-main rounded-sm"
          />
          {errors.name && (
            <p className="text-destructive text-xs mt-1">
              {errors.name.message}
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium mb-2 text-text-main">
            Email
          </label>
          <input
            type="email"
            {...register('email')}
            className="w-full px-4 py-2 bg-black/50 border border-border focus:border-primary text-text-main rounded-sm"
          />
          {errors.email && (
            <p className="text-destructive text-xs mt-1">
              {errors.email.message}
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium mb-2 text-text-main">
            Password
          </label>
          <input
            type="password"
            {...register('password')}
            className="w-full px-4 py-2 bg-black/50 border border-border focus:border-primary text-text-main rounded-sm"
          />
          {errors.password && (
            <p className="text-destructive text-xs mt-1">
              {errors.password.message}
            </p>
          )}
        </div>

         {/* 🔥 Checkbox INSIDE form */}
<div className="mt-4 flex items-start space-x-2 text-sm">
  <input
    type="checkbox"
    checked={agreed}
    onChange={(e) => setAgreed(e.target.checked)}
    className="mt-1"
  />
  <label>
    I have read and agree to the{" "}
    <a
      href="/terms"
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-400 underline"
    >
      Terms of Service
    </a>
  </label>
</div>
<button
  type="submit"
  disabled={loading || !agreed}
  className={`w-full bg-primary text-primary-foreground hover:bg-primary/90 font-bold uppercase tracking-wider p ${
    loading || !agreed ? "opacity-50 cursor-not-allowed" : ""
  }`}
>
  {loading ? 'CREATING ACCOUNT...' : 'REGISTER'}
</button>
</form>
      <div className="mt-4 text-center">
        <p className="text-sm text-text-muted">
          Already have an account?{' '}
          <Link to="/login" className="text-primary hover:underline">
            Login
          </Link>
        </p>
      </div>
    </div>
 </div>

);

}
